import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { BORDER, NAVY, TEXT_SECONDARY } from "../../../theme/tokens";

/** Lightweight card matching the editor's SectionCard look. */
export const TabCard: React.FC<{
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  right?: React.ReactNode;
  children: React.ReactNode;
  sx?: object;
}> = ({ title, subtitle, icon, right, children, sx }) => (
  <Paper elevation={0} sx={{ border: `1px solid ${BORDER}`, borderRadius: 3, overflow: "hidden", ...sx }}>
    {(title || right) && (
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        px: 2.5, py: 1.75, borderBottom: `1px solid ${BORDER}`, gap: 2,
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          {icon && <Box sx={{ color: NAVY, display: "flex" }}>{icon}</Box>}
          <Box>
            {title && <Typography sx={{ fontWeight: 800, fontSize: 15, color: NAVY }}>{title}</Typography>}
            {subtitle && <Typography sx={{ fontSize: 12, color: TEXT_SECONDARY }}>{subtitle}</Typography>}
          </Box>
        </Box>
        {right}
      </Box>
    )}
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Paper>
);

/** Shown when a menu isn't in a playlist group yet (scheduling lives on the group). */
export const NeedsGroup: React.FC<{ what?: string }> = ({ what = "Scheduling" }) => (
  <TabCard>
    <Box sx={{ textAlign: "center", py: 5 }}>
      <Typography sx={{ fontWeight: 700, color: NAVY, mb: 0.5 }}>
        {what} needs a Playlist Group
      </Typography>
      <Typography sx={{ fontSize: 13, color: TEXT_SECONDARY, maxWidth: 460, mx: "auto" }}>
        Menu schedules are configured on the playlist group (a restaurant's weekly
        schedule). Assign this menu to a group on the <b>Content</b> tab, then return here.
      </Typography>
    </Box>
  </TabCard>
);
